import PropTypes from "prop-types"

import PlusIcon from "shared/components/icons/plus_icon"
import { verifyIntendedPromiseRejection } from "./utils/modal_promise"

import "./diy_add_tanda_button.scss"

export default function DIYAddTandaButton({
  allowNewBadge,
  anchorTitle,
  onClick,
}) {
  return (
    <a
      className="plus-icon-button"
      styleName="add"
      onClick={verifyIntendedPromiseRejection(onClick)}
      title={anchorTitle}
      data-allow-new-badge={allowNewBadge}
    >
      <PlusIcon />
    </a>
  )
}

DIYAddTandaButton.propTypes = {
  allowNewBadge: PropTypes.string.isRequired,
  anchorTitle: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
}
